export const SET_TRAVEL_DATA = "SET_TRAVEL_DATA";
export const RESET = "RESET";
export const SET_PRICE = "SET_PRICE";
